export const ADD_SEARCH_TAG = 'ADD_SEARCH_TAG'
export const REMOVE_SEARCH_TAG = 'REMOVE_SEARCH_TAG'
export const CLEAR_SEARCH_TAG = 'CLEAR_SEARCH_TAG'
